import React, { useState } from "react";
import { Grid, Box } from "@mui/material";
import { farmers } from "../../config/images";
import translations from "../../config/language";

const FarmOwnershipDetails = ({ selectedFarmer }) => {
    const language = process.env.REACT_APP_LANGUAGE;

    return (
        <>
            <div className="user-profile" >
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", paddingLeft:"20px" }}
                    >{translations[language].farmOwnership}
                    </Grid>
                    <Grid item lg={3} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                        {translations[language].owned}: {translations[language].titled}
                    </Grid>
                    <Grid item lg={5} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                        {translations[language].leased}: {translations[language].untitled}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft:"20px" }}>{translations[language].infrastructureDetails}</Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].farmerHouse}</Grid>
                    <Grid item lg={5} className="grid-item" style={{ fontWeight: 700 }}>8 My Street, Ilassan Lekki, Lagos 1051</Grid>
                    <Grid item lg={3} className="grid-item" style={{ fontWeight: 700 }}>
                        <div style={{ display: "flex", gap: "10px", fontWeight: 700 }}>
                            <div >2.5 Hectors</div>
                            <img src={farmers.locationDetailsImage} alt="loaction-img" className="" />
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].farmer}</Grid>
                    <Grid item lg={5} className="grid-item" style={{ fontWeight: 700 }}>8 My Street, Ilassan Lekki, Lagos 1051</Grid>
                    <Grid item lg={3} className="grid-item" style={{ fontWeight: 700 }}>
                        <div style={{ display: "flex", gap: "10px", fontWeight: 700 }}>
                            <div >2500 sq m</div>
                            <img src={farmers.locationDetailsImage} alt="loaction-img" className="" />
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].warehouse}</Grid>
                    <Grid item lg={5} className="grid-item" style={{ fontWeight: 700 }}>8 My Street, Ilassan Lekki, Lagos 1051</Grid>
                    <Grid item lg={3} className="grid-item" style={{ fontWeight: 700 }}>
                        <div style={{ display: "flex", gap: "10px", fontWeight: 700 }}>
                            <div >3500 sq m</div>
                            <img src={farmers.locationDetailsImage} alt="loaction-img" className="" />
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].accessToRoadAndDistance}</Grid>
                    <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].available}</Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].processingPlants}</Grid>
                    <Grid item lg={5} className="grid-item" style={{ fontWeight: 700 }}>8 My Street, Ilassan Lekki, Lagos 1051</Grid>
                    <Grid item lg={3} className="grid-item" style={{ fontWeight: 700 }}>
                        <div style={{ display: "flex", gap: "10px", fontWeight: 700 }}>
                            <div >3500 sq m</div>
                            <img src={farmers.locationDetailsImage} alt="loaction-img" className="" />
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].accessToRoadAndDistance}</Grid>
                    <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].notAvailable}</Grid>
                </Grid>
                <Grid container >
                    <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft:"20px" }}>{translations[language].typesOfMachinery}</Grid>
                </Grid>
                <Grid container >
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].tillageEquipment}</Grid>
                    <Grid item lg={2} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].industrial}: 04</Grid>
                    <Grid item lg={2} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].mini}: 02</Grid>
                    <Grid item lg={4} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].handPush} 01</Grid>
                </Grid>
                <Grid container >
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].plows}</Grid>
                    <Grid item lg={2} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].moldboard}: 04</Grid>
                    <Grid item lg={6} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].disc}: 02</Grid>
                </Grid>
                <Grid container >
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].harrows}</Grid>
                    <Grid item lg={2} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].moldboard}: 04</Grid>
                    <Grid item lg={6} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].disc}: 02</Grid>
                </Grid>
                <Grid container >
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].plantingEquipment}</Grid>
                    <Grid item lg={2} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].speedDrills}: 04</Grid>
                    <Grid item lg={6} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].planters}: 01</Grid>
                </Grid>
                <Grid container >
                    <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].transplanter}</Grid>
                    <Grid item lg={2} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].rice}: 04</Grid>
                    <Grid item lg={6} className="grid-item" style={{ fontWeight: 700 }}>{translations[language].vegetables}: 02</Grid>
                </Grid>


            </div>
        </>
    )
}

export default FarmOwnershipDetails;